export const ELEMENT_IDS = { MOBILE_BACK: 'mobile_preview_back' };
